// MAISON D'ESTEBAN 2.0 — pagina de produs (sections/est-pdp-main.liquid). Portat din assets/gt-pdp.js (GT 2.0 ← Nubra 2.0).
// Galerie (mobil: glisare + puncte + contor; pozele 2+ cu sursa amânată) · „Adaugă în coș” = 1 bucată, un singur /cart/add.js +
// CartLinesUpdateEvent (sertarul coșului se deschide ca la butonul temei); oferta 2+1 e doar explicată, reducerea BXGY o face coșul
// · bara lipită jos pe mobil apare DUPĂ ce butonul principal a ieșit din ecran (R11.6).
const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
const fill = (tpl, map) => String(tpl || '').replace(/\[(\w+)\]/g, (m, k) => (k in map ? map[k] : m));

// „Văzute recent” (P13.13): aceeași cheie ca assets/est-recent.js — pagina de produs se înregistrează chiar fără secțiunea est-recent.
function recordRecent(handle) {
  if (!handle) return;
  try {
    const list = (JSON.parse(localStorage.getItem('est_recent') || '[]') || []).filter((x) => x && x.h && x.h !== handle);
    list.unshift({ h: handle, t: Date.now() });
    localStorage.setItem('est_recent', JSON.stringify(list.slice(0, 12)));
  } catch (e) { /* mod privat / blocat */ }
}

// P13.4 — vizualizatorul de zoom. Construit o singură dată, la primul clic (pozele mari stau într-un <template> până atunci).
class EstZoom {
  constructor(tpl) {
    document.body.appendChild(tpl.content.cloneNode(true));
    this.dlg = document.body.lastElementChild;
    if (!(this.dlg instanceof HTMLDialogElement)) this.dlg = document.querySelector('dialog.estp-zm:last-of-type');
    const q = (s) => this.dlg.querySelector(s);
    this.track = q('[data-zm-track]');
    this.slides = [...this.dlg.querySelectorAll('.estp-zm-slide')];
    this.cur = q('[data-zm-cur]');
    this.hint = q('[data-zm-hint]');
    this.i = 0;
    this.s = 1; this.x = 0; this.y = 0;
    this.ptrs = new Map();
    this.lastTap = 0;
    q('[data-zm-close]')?.addEventListener('click', () => this.dlg.close());
    q('[data-zm-prev]')?.addEventListener('click', () => this.go(this.i - 1));
    q('[data-zm-next]')?.addEventListener('click', () => this.go(this.i + 1));
    q('[data-zm-in]')?.addEventListener('click', () => this.zoomTo(Math.min(4, this.s + 1)));
    q('[data-zm-out]')?.addEventListener('click', () => this.zoomTo(Math.max(1, this.s - 1)));
    this.track.addEventListener('scroll', () => {
      if (this.s > 1) return;
      const i = Math.round(this.track.scrollLeft / Math.max(1, this.track.clientWidth));
      if (i !== this.i) { this.i = i; this.update(); }
    }, { passive: true });
    this.dlg.addEventListener('keydown', (e) => this.key(e));
    this.dlg.addEventListener('close', () => { this.reset(); if (this.opener) this.opener.focus(); });
    this.track.addEventListener('pointerdown', (e) => this.down(e));
    this.track.addEventListener('pointermove', (e) => this.move(e));
    ['pointerup', 'pointercancel', 'pointerleave'].forEach((n) => this.track.addEventListener(n, (e) => this.up(e)));
    this.track.addEventListener('wheel', (e) => {
      if (!e.ctrlKey && Math.abs(e.deltaX) > Math.abs(e.deltaY)) return; // glisare orizontală cu touchpad-ul
      e.preventDefault();
      const r = this.pan().getBoundingClientRect();
      this.zoomAt(Math.min(4, Math.max(1, this.s * (e.deltaY < 0 ? 1.15 : 1 / 1.15))), e.clientX, e.clientY, r);
    }, { passive: false });
  }

  open(i, opener) {
    this.opener = opener;
    this.dlg.showModal();
    this.go(i, true);
    this.dlg.querySelector('[data-zm-close]')?.focus();
    if (this.hint) { this.hint.classList.remove('is-off'); clearTimeout(this._h); this._h = setTimeout(() => this.hint.classList.add('is-off'), 2600); }
  }

  go(i, instant) {
    const n = this.slides.length;
    this.reset();
    this.i = Math.max(0, Math.min(n - 1, i));
    this.track.scrollTo({ left: this.i * this.track.clientWidth, behavior: instant || reduceMotion.matches ? 'auto' : 'smooth' });
    this.update();
  }

  update() {
    if (this.cur) this.cur.textContent = String(this.i + 1);
    const prev = this.dlg.querySelector('[data-zm-prev]');
    const next = this.dlg.querySelector('[data-zm-next]');
    if (prev) prev.disabled = this.i === 0;
    if (next) next.disabled = this.i >= this.slides.length - 1;
  }

  pan() { return this.slides[this.i].querySelector('[data-zm-pan]'); }

  apply() {
    const el = this.pan();
    const w = el.offsetWidth; const h = el.offsetHeight; // mărimea netransformată
    const mx = ((this.s - 1) * w) / 2; const my = ((this.s - 1) * h) / 2;
    this.x = Math.max(-mx, Math.min(mx, this.x));
    this.y = Math.max(-my, Math.min(my, this.y));
    el.style.transform = this.s > 1 ? `translate3d(${this.x}px, ${this.y}px, 0) scale(${this.s})` : '';
    this.track.classList.toggle('is-zoomed', this.s > 1);
    const img = el.querySelector('img');
    if (img && this.s > 1.4 && img.sizes !== '200vw') img.sizes = '200vw'; // cere varianta mare (2048) abia la zoom
  }

  // zoom spre punctul (cx, cy) de pe ecran: punctul de sub deget / cursor rămâne pe loc
  zoomAt(ns, cx, cy, rect) {
    const r = rect || this.pan().getBoundingClientRect();
    const ox = r.left + r.width / 2 - this.x; // centrul elementului netransformat
    const oy = r.top + r.height / 2 - this.y;
    const k = ns / this.s;
    this.x = (cx - ox) - k * (cx - ox - this.x);
    this.y = (cy - oy) - k * (cy - oy - this.y);
    this.s = ns;
    if (this.s <= 1.01) { this.s = 1; this.x = 0; this.y = 0; }
    this.apply();
  }

  zoomTo(ns) {
    const r = this.pan().getBoundingClientRect();
    this.zoomAt(ns, r.left + r.width / 2, r.top + r.height / 2, r);
  }

  reset() {
    this.s = 1; this.x = 0; this.y = 0;
    this.ptrs.clear();
    this.slides.forEach((sl) => { const p = sl.querySelector('[data-zm-pan]'); if (p) p.style.transform = ''; });
    this.track?.classList.remove('is-zoomed');
  }

  down(e) {
    this.ptrs.set(e.pointerId, { x: e.clientX, y: e.clientY });
    this.moved = false;
    this.start = { x: e.clientX, y: e.clientY, tx: this.x, ty: this.y, s: this.s };
    if (this.ptrs.size === 2) {
      const [a, b] = [...this.ptrs.values()];
      this.pinch = { d: Math.hypot(a.x - b.x, a.y - b.y) || 1, s: this.s };
    }
    if (this.s > 1 || this.ptrs.size === 2) { try { this.track.setPointerCapture(e.pointerId); } catch (err) { /* */ } }
  }

  move(e) {
    if (!this.ptrs.has(e.pointerId)) return;
    this.ptrs.set(e.pointerId, { x: e.clientX, y: e.clientY });
    if (Math.hypot(e.clientX - this.start.x, e.clientY - this.start.y) > 8) this.moved = true;
    if (this.ptrs.size === 2 && this.pinch) {
      const [a, b] = [...this.ptrs.values()];
      const d = Math.hypot(a.x - b.x, a.y - b.y);
      const ns = Math.min(4, Math.max(1, (this.pinch.s * d) / this.pinch.d));
      this.zoomAt(ns, (a.x + b.x) / 2, (a.y + b.y) / 2);
      e.preventDefault();
    } else if (this.ptrs.size === 1 && this.s > 1) {
      this.x = this.start.tx + (e.clientX - this.start.x);
      this.y = this.start.ty + (e.clientY - this.start.y);
      this.apply();
      e.preventDefault();
    }
  }

  up(e) {
    if (!this.ptrs.has(e.pointerId)) return;
    this.ptrs.delete(e.pointerId);
    if (this.ptrs.size < 2) this.pinch = null;
    if (e.type !== 'pointerup' || this.moved || this.ptrs.size) return;
    // dublu-tap (atingere) / clic (mouse): comută 1× ↔ 2,5× în punctul atins
    const now = Date.now();
    const isTouch = e.pointerType !== 'mouse';
    if (!isTouch || now - this.lastTap < 320) {
      this.lastTap = 0;
      this.zoomAt(this.s > 1 ? 1 : 2.5, e.clientX, e.clientY);
    } else {
      this.lastTap = now;
    }
  }

  key(e) {
    if (e.key === 'ArrowRight') { e.preventDefault(); this.go(this.i + 1); }
    else if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(this.i - 1); }
    else if (e.key === '+' || e.key === '=') { e.preventDefault(); this.zoomTo(Math.min(4, this.s + 1)); }
    else if (e.key === '-') { e.preventDefault(); this.zoomTo(Math.max(1, this.s - 1)); }
    else if (e.key === 'Tab') {
      // focus prins în vizualizator (pe lângă inert-ul nativ al <dialog> modal)
      const f = [...this.dlg.querySelectorAll('button:not([disabled])')].filter((b) => b.offsetParent !== null);
      if (!f.length) return;
      const first = f[0]; const last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }
}

let eventsMod = null;
const eventsReady = import('@shopify/events').then((m) => (eventsMod = m)).catch(() => null);

class EstPdp {
  constructor(root) {
    this.root = root;
    try {
      this.cfg = JSON.parse(root.querySelector('[data-estp-config]')?.textContent || '{}');
    } catch {
      this.cfg = {};
    }
    this.t = this.cfg.t || {};
    this.$ = (s) => root.querySelector(s);
    this.gallery();
    this.bind();
    this.sticky();
    // P13 (10 oct 2026): fiecare pornește doar dacă elementul lui există în pagină (comutatoarele din setările secțiunii)
    this.zoom();
    this.orig();
    this.eta();
    this.ago();
    this.cta();
    recordRecent(this.cfg.handle);
  }

  /* ---------- P13.4 zoom: vizualizator pe tot ecranul (ciupire / dublu-tap / rotiță, glisare, săgeți, Esc, focus prins) ---------- */
  zoom() {
    const tpl = this.$('[data-estp-zoom-tpl]');
    if (!tpl) return;
    this.root.addEventListener('click', (e) => {
      const b = e.target instanceof Element && e.target.closest('[data-estp-zoom]');
      if (!b) return;
      e.preventDefault();
      this.openZoom(Number(b.dataset.estpZoom) || 0, b, tpl);
    });
  }

  openZoom(index, opener, tpl) {
    if (!this.zm) this.zm = new EstZoom(tpl);
    this.zm.open(index, opener);
  }

  /* ---------- P13.9 fereastra „Despre original” ---------- */
  orig() {
    const btn = this.$('[data-estp-orig]');
    if (!btn) return;
    const dlg = document.getElementById(btn.dataset.estpOrig);
    if (!dlg) return;
    btn.addEventListener('click', () => {
      dlg.querySelectorAll('img[data-src]').forEach((im) => {
        im.srcset = im.getAttribute('data-srcset') || '';
        im.src = im.getAttribute('data-src');
        im.removeAttribute('data-src');
        im.removeAttribute('data-srcset');
      });
      dlg.showModal();
      dlg.querySelector('[data-estp-orig-close]')?.focus();
    });
    dlg.addEventListener('click', (e) => {
      if (e.target === dlg || (e.target instanceof Element && e.target.closest('[data-estp-orig-close]'))) dlg.close();
    });
    dlg.addEventListener('close', () => btn.focus());
  }

  /* ---------- P13.3 estimarea livrării (ora României, zile lucrătoare, sărbători) ---------- */
  eta() {
    const el = this.$('[data-estp-eta]');
    if (!el) return;
    const out = el.querySelector('[data-estp-eta-t]');
    const d = el.dataset;
    const cutH = Number(d.cutH || 14);
    const cutM = Number(d.cutM || 0);
    const transit = Math.max(0, Number(d.transit || 2));
    const days = (s) => new Set(String(s || '').split(/[^0-9]+/).filter(Boolean).map((x) => Number(x) % 7)); // 7 = duminică = 0
    const ship = days(d.ship || '1,2,3,4,5');
    const deliv = days(d.deliv || '1,2,3,4,5');
    const hol = String(d.hol || '').split(',').map((x) => x.trim()).filter(Boolean);
    const pad = (n) => String(n).padStart(2, '0');
    const isHol = (t) => {
      const x = new Date(t);
      const dm = `${pad(x.getUTCDate())}.${pad(x.getUTCMonth() + 1)}`;
      const iso = `${x.getUTCFullYear()}-${pad(x.getUTCMonth() + 1)}-${dm.slice(0, 2)}`;
      return hol.includes(dm) || hol.includes(iso);
    };
    const DAY = 86400000;
    const ZI = ['duminică', 'luni', 'marți', 'miercuri', 'joi', 'vineri', 'sâmbătă'];
    const LUNA = ['ian', 'feb', 'mar', 'apr', 'mai', 'iun', 'iul', 'aug', 'sep', 'oct', 'nov', 'dec'];
    const esc = (t) => String(t).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    let fmt;
    try {
      fmt = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Bucharest', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', hourCycle: 'h23' });
    } catch (e) { fmt = null; }
    // „ceasul de perete” din București, ca timestamp UTC (fără probleme de fus orar al vizitatorului)
    const wall = () => {
      if (!fmt) { const n = new Date(); return Date.UTC(n.getFullYear(), n.getMonth(), n.getDate(), n.getHours(), n.getMinutes(), n.getSeconds()); }
      const o = {};
      fmt.formatToParts(new Date()).forEach((p) => { o[p.type] = Number(p.value); });
      return Date.UTC(o.year, o.month - 1, o.day, o.hour % 24, o.minute, o.second);
    };
    const tick = () => {
      const now = wall();
      const today = now - (now % DAY);
      // ziua expedierii: azi înainte de ora limită, altfel următoarea zi de expediere (fără sărbători)
      let shipDay = today;
      let guard = 0;
      while (guard++ < 30) {
        const okDay = ship.has(new Date(shipDay).getUTCDay()) && !isHol(shipDay);
        const cutoff = shipDay + (cutH * 60 + cutM) * 60000;
        if (okDay && now < cutoff) break;
        shipDay += DAY;
      }
      const cutoffAt = shipDay + (cutH * 60 + cutM) * 60000;
      // livrarea: N zile de livrare ale curierului după expediere
      let del = shipDay;
      let n = 0;
      guard = 0;
      while (n < transit && guard++ < 40) {
        del += DAY;
        if (deliv.has(new Date(del).getUTCDay()) && !isHol(del)) n += 1;
      }
      const dd = new Date(del);
      let date = `${ZI[dd.getUTCDay()]}, ${dd.getUTCDate()} ${LUNA[dd.getUTCMonth()]}`;
      if (del - today === DAY && d.tomorrow) date = `${d.tomorrow}, ${date}`;
      const left = Math.max(0, cutoffAt - now);
      const h = Math.floor(left / 3600000);
      const m = Math.floor((left % 3600000) / 60000);
      const time = h > 0 ? `${h} h ${m} min` : `${Math.max(1, m)} min`;
      const tplText = left > 24 * 3600000 ? (d.far || d.text) : d.text;
      out.innerHTML = esc(tplText || '').replace('[timp]', `<b>${esc(time)}</b>`).replace('[data]', `<b>${esc(date)}</b>`);
      el.classList.add('is-ready');
    };
    tick();
    this._eta = setInterval(tick, 30000);
    document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') tick(); });
  }

  /* ---------- P13.15 timpul relativ al comentariilor („acum 3 zile”) ---------- */
  ago() {
    const els = this.root.querySelectorAll('time[data-estp-ago]');
    if (!els.length) return;
    const now = Date.now();
    const one = (n, a, b) => (n === 1 ? a : `${n} ${n >= 20 ? 'de ' : ''}${b}`);
    els.forEach((t) => {
      const ts = Date.parse(t.getAttribute('datetime') || '');
      if (!ts) return;
      const s = Math.max(0, (now - ts) / 1000);
      let txt;
      if (s < 3600) txt = `acum ${one(Math.max(1, Math.round(s / 60)), 'un minut', 'minute')}`;
      else if (s < 86400) txt = `acum ${one(Math.round(s / 3600), 'o oră', 'ore')}`;
      else if (s < 86400 * 7) txt = `acum ${one(Math.round(s / 86400), 'o zi', 'zile')}`;
      else if (s < 86400 * 30) txt = `acum ${one(Math.round(s / 604800), 'o săptămână', 'săptămâni')}`;
      else if (s < 86400 * 365) txt = `acum ${one(Math.round(s / 2592000), 'o lună', 'luni')}`;
      else txt = `acum ${one(Math.round(s / 31536000), 'un an', 'ani')}`;
      t.textContent = txt;
    });
  }

  /* ---------- măsurare: click pe elementele noi [data-est-cta] → evenimentul „est:cta” (est-track.js îl poate prelua) ---------- */
  cta() {
    this.root.addEventListener('click', (e) => {
      const el = e.target instanceof Element && e.target.closest('[data-est-cta]');
      if (!el) return;
      document.dispatchEvent(new CustomEvent('est:cta', { detail: { cta: el.dataset.estCta, productId: String(this.cfg.pid || ''), name: this.cfg.name || '' } }));
    });
  }

  gallery() {
    const track = this.$('[data-estp-track]');
    if (!track) return;
    this.deferImages(track);
    this.track = track;
    this.gi = 0;
    const dots = [...this.root.querySelectorAll('.estp-dots i')];
    const cur = this.$('[data-estp-cur]');
    const onScroll = () => {
      if (track.scrollWidth <= track.clientWidth + 2) return; // desktop: grilă, fără glisare
      const i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      if (i === this.gi) return;
      this.gi = i;
      dots.forEach((d, j) => d.classList.toggle('on', j === i));
      if (cur) cur.textContent = String(i + 1);
    };
    track.addEventListener('scroll', onScroll, { passive: true });
    track.addEventListener('keydown', (e) => {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      if (track.scrollWidth <= track.clientWidth + 2) return;
      const n = track.children.length;
      const i = Math.max(0, Math.min(n - 1, this.gi + (e.key === 'ArrowRight' ? 1 : -1)));
      track.scrollTo({ left: i * track.clientWidth, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      e.preventDefault();
    });
  }

  // Pozele 2+ vin cu data-src / data-srcset: pe desktop (grilă) imediat; pe mobil la prima atingere / derulare a galeriei
  // sau după load + idle, cu IntersectionObserver pe bandă (practici §13.4: lazy nu ajunge în caruselele orizontale).
  deferImages(track) {
    const imgs = [...track.querySelectorAll('img[data-estp-defer]')];
    if (!imgs.length) return;
    const show = (im) => {
      if (!im.hasAttribute('data-src')) return;
      im.srcset = im.getAttribute('data-srcset') || '';
      im.src = im.getAttribute('data-src');
      im.removeAttribute('data-srcset');
      im.removeAttribute('data-src');
    };
    const all = () => imgs.forEach(show);
    const mq = window.matchMedia('(min-width: 990px)');
    if (mq.matches || !('IntersectionObserver' in window)) { all(); return; }
    mq.addEventListener?.('change', (e) => { if (e.matches) all(); });
    let started = false;
    const start = () => {
      if (started) return;
      started = true;
      const io = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { show(e.target); io.unobserve(e.target); } }), { root: track, rootMargin: '0px 50% 0px 50%' });
      imgs.forEach((im) => io.observe(im));
    };
    ['pointerdown', 'touchstart', 'scroll', 'keydown', 'focusin'].forEach((ev) => track.addEventListener(ev, start, { once: true, passive: true }));
    const later = () => (window.requestIdleCallback || ((f) => setTimeout(f, 300)))(start, { timeout: 1500 });
    if (document.readyState === 'complete') later(); else window.addEventListener('load', later, { once: true });
  }

  bind() {
    this.$('[data-estp-form]')?.addEventListener('submit', (e) => {
      e.preventDefault();
      this.buy('pdp');
    });
    this.$('.estp-sbar [data-estp-buy]')?.addEventListener('click', (e) => {
      e.preventDefault();
      this.buy('pdp_sticky');
    });
  }

  buy(src = 'pdp') {
    if (!this.cfg.available) return;
    this.addItems([{ id: Number(this.cfg.variant), quantity: 1 }], fill(this.t.ok, { produs: this.cfg.name }), src);
  }

  sectionIds() {
    return [...document.querySelectorAll('cart-items-component')].map((c) => c instanceof HTMLElement && c.dataset.sectionId).filter(Boolean);
  }

  async addItems(items, okMsg, src = 'pdp') {
    await eventsReady;
    const btns = [...this.root.querySelectorAll('[data-estp-buy]')];
    btns.forEach((b) => { b.setAttribute('aria-busy', 'true'); b.disabled = true; });
    const msg = this.$('[data-estp-msg]');
    if (msg) msg.textContent = '';
    const routes = window.Theme?.routes || {};
    let deferred = null;
    if (eventsMod?.CartLinesUpdateEvent) {
      const { CartLinesUpdateEvent } = eventsMod;
      deferred = CartLinesUpdateEvent.createPromise();
      this.root.dispatchEvent(new CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: items.map((it) => ({ merchandiseId: String(it.id), quantity: it.quantity })),
        promise: deferred.promise,
      }));
    }
    try {
      const res = await fetch(routes.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items, sections: this.sectionIds().join(',') }),
      }).then((r) => r.json());
      if (res.status) throw Object.assign(new Error(res.description || res.message || 'add'), { res });
      const cart = await fetch(`${routes.cart_url || '/cart'}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
      if (deferred) {
        deferred.resolve({
          cart: eventsMod.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail: { items: cart.items, source: 'est-pdp', sourceId: this.root.id, itemCount: items.reduce((s, it) => s + it.quantity, 0), productId: String(this.cfg.handle), sections: res.sections, didError: false },
        });
      } else {
        window.location.href = routes.cart_url || '/cart';
      }
      /* măsurare (P10.5): sursa adăugării în coș — o citește est-track.js */
      document.dispatchEvent(new CustomEvent('est:atc', { detail: { source: src, productId: String(this.cfg.pid || ''), name: this.cfg.name, price: this.cfg.price, items } }));
      if (!document.querySelector('cart-drawer-component[auto-open], [auto-open]')) this.toast(okMsg);
      return true;
    } catch (error) {
      if (deferred) deferred.reject(error);
      if (eventsMod?.CartErrorEvent) this.root.dispatchEvent(new eventsMod.CartErrorEvent({ error: error?.message || 'Add to cart failed', code: error?.res ? 'INVALID' : 'SERVICE_UNAVAILABLE' }));
      const text = error?.res?.description || this.t.err;
      if (msg) msg.textContent = text; else this.toast(text);
      return false;
    } finally {
      btns.forEach((b) => { b.removeAttribute('aria-busy'); b.disabled = false; });
    }
  }

  toast(text) {
    const t = this.$('[data-estp-toast]');
    if (!t || !text) return;
    t.textContent = text;
    t.classList.add('show');
    clearTimeout(this._toast);
    this._toast = setTimeout(() => t.classList.remove('show'), 2600);
  }

  sticky() {
    const bar = this.$('[data-estp-sbar]');
    const atc = this.$('.estp-form .estp-btn');
    if (!bar || !atc || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver(([en]) => {
      // apare doar după ce butonul principal a ieșit din ecran PRIN DERULARE (e deasupra ecranului), nu cât timp e încă dedesubt
      const show = !en.isIntersecting && en.boundingClientRect.bottom < 0;
      bar.classList.toggle('show', show);
      bar.setAttribute('aria-hidden', String(!show));
      bar.querySelector('button')?.setAttribute('tabindex', show ? '0' : '-1');
    });
    io.observe(atc);
  }
}

function boot() {
  document.querySelectorAll('[data-estp]').forEach((el) => {
    if (el.__estp) return;
    el.__estp = new EstPdp(el);
  });
}
boot();
document.addEventListener('shopify:section:load', boot);
